import { DateTime } from "luxon";
import Manager from "@/inside/models/Manager";

/**
 * @property {boolean} canAssessAll
 * @property {DateTime|null} demoEndDate
 * @property {string|null} id
 * @property {string|null} language
 * @property {Manager|null} manager
 * @property {string|null} name
 * @property {string} type
 * @property {boolean} canTranslate
 */
export default class Account {
    constructor() {
        this.canAssessAll = true;
        this.demoEndDate = null;
        this.id = null;
        this.language = "fr";
        this.manager = null;
        this.name = null;
        this.canExport = {
            watch: true,
            actions: true
        };
        this.type = "classic";
        this.website = null;
        this.workforce = null;
        this.canTranslate = false;
    }

    /**
     * Returns a new `Account` instance hydrated with data from given `api_resource`.
     *
     * @param {Object} api_resource
     * @return {Account}
     */
    static fromAPI(api_resource) {
        const out = new Account();
        return Object.assign(out, {
            canAssessAll: api_resource.canAssessAll,
            demoEndDate: (api_resource.demoEndDate !== null
                ? DateTime.fromISO(api_resource.demoEndDate)
                : null
            ),
            id: api_resource.id,
            language: api_resource.language,
            manager: (api_resource.manager !== null
                ? Object.freeze(Manager.fromAPI(api_resource.manager))
                : null
            ),
            name: api_resource.name,
            canExport: Object.assign(out.canExport, api_resource.canExport),
            type: api_resource.type,
            workforce: api_resource.workforce,
            website: api_resource.website,
            canTranslate: api_resource.canTranslate
        });
    }
}
